// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-right-between-rows';

export const Component = () => (
  <path d='m11.159 11.59.814.67-5.125 5.077-.67-.67 3.927-3.927H0v-.958h10.105L6.178 7.855l.67-.67 4.31 4.406ZM5.889.959V0H24.52v24.521H5.89v-.958h17.672v-5.89H13.219v-1.006h10.345V7.855H13.217V6.849h10.345V.96H5.89V.958Z' />
);

export const viewBox = '0 0 25 25';
